<template>
  <span class="currencysymbol" :class="{'fontWeight':fontWeight}"> {{getSymbolFromCurrency($store.state.checkoutcurrency)}} </span>
</template>
<script>
import getSymbolFromCurrency from "currency-symbol-map";
export default {
  props:['fontWeight'],
  data() {
    return {
      getSymbolFromCurrency:""
    };
  },
  beforeMount(){
    this.getSymbolFromCurrency=getSymbolFromCurrency;
  }
};
</script>
<style scoped lang='scss'>
.currencysymbol{
  display: inline-block;
}
.fontWeight{
  font-weight: 600;
}

</style>
